import { render, staticRenderFns } from "./ContactInfoDialog.vue?vue&type=template&id=6857512e&scoped=true"
import script from "./ContactInfoDialog.vue?vue&type=script&lang=js"
export * from "./ContactInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoDialog.vue?vue&type=style&index=0&id=6857512e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6857512e",
  null
  
)

export default component.exports